import Service from "../../Service";

const resource = "HmnStaffingRequirement/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "auditHistory", parameters, {
      params: { requestID: requestID },
    });
  },
  audit(payload, requestID) {
    return Service.post(resource + "audit", payload, {
      params: { requestID: requestID },
    });
  }
};
